import { createContext, useContext, useState } from 'react';

const MediaLibraryContext = createContext();

// The video-questions library has two scopes: "My Videos" (own Personal +
// own Shared) and "shared_library" (every company-wide Shared video). An owner's own
// Shared video shows up in both - intentional.
export const MY_VIDEOS_SCOPE = 'my_videos';
export const SHARED_LIBRARY_SCOPE = 'shared_library';

// Backend `default_audience` values (video_library_data_source_actions.py) map
// onto these FE scope ids.
export const BACKEND_AUDIENCE_TO_FE_SCOPE = {
    mine: MY_VIDEOS_SCOPE,
    shared: SHARED_LIBRARY_SCOPE,
};

function defaultScopeFrom(metadata) {
    const videoQuestions = (metadata || []).find((category) => category.id === 'video_questions');
    return BACKEND_AUDIENCE_TO_FE_SCOPE[videoQuestions?.default_audience] || MY_VIDEOS_SCOPE;
}

export function MediaLibraryProvider({ metadata, handleSelectMedia, children }) {
    const [activeLibrary, setActiveLibrary] = useState('video_questions'); // TODO: handle default + update with setActiveLibrary once we have multiple libraries
    // Which tab opens first is backend material: a user with no
    // personal videos should not open onto an empty "My Videos" tab.
    const [activeScope, setActiveScope] = useState(() => defaultScopeFrom(metadata));

    return (
        <MediaLibraryContext.Provider
            value={{
                mediaLibraryMetadata: metadata,
                activeLibrary,
                activeScope,
                setActiveScope,
                handleSelectMedia,
            }}
        >
            {children}
        </MediaLibraryContext.Provider>
    );
}

export function useMediaLibrary() {
    const context = useContext(MediaLibraryContext);
    if (context === undefined) {
        throw new Error('useMediaLibrary must be used within a MediaLibraryProvider');
    }
    return context;
}
